import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  link: null,
  open: false,
};

const slice = createSlice({
  name: 'fan2fan',
  initialState: initialState,
  reducers: {
    setLink: (state, { payload }) => ({
      ...state,
      link: payload,
    }),
    setOpen: (state, { payload }) => ({
      ...state,
      open: payload,
    }),
    setShowFan2Fan: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    restore: () => initialState,
  },
});

export const { setLink, setOpen, setShowFan2Fan, restore } = slice.actions;

export default slice.reducer;
